import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    try {
      sessionStorage.removeItem('chunk_load_failed_reload');
    } catch (e) {
      // ignore
    }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error', error, errorInfo);

    // Auto-reload on ChunkLoadError (common during production redeployments)
    const errorMsg = error?.message || '';
    const errorName = error?.name || '';
    const isChunkLoadFailed =
      errorName === 'ChunkLoadError' ||
      errorMsg.includes('Loading chunk') ||
      errorMsg.includes('Loading CSS chunk');

    if (isChunkLoadFailed) {
      try {
        const chunkErrorKey = 'chunk_load_failed_reload';
        const hasReloaded = sessionStorage.getItem(chunkErrorKey);
        if (!hasReloaded) {
          sessionStorage.setItem(chunkErrorKey, 'true');
          window.location.reload();
        }
      } catch (e) {
        console.error('Failed to handle ChunkLoadError auto-reload', e);
      }
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 text-center">
          <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mb-6">
            <svg
              className="w-8 h-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Something went wrong
          </h1>
          <p className="text-gray-600 max-w-md mb-8">
            The application encountered an unexpected error. We've been notified
            and are working on it.
          </p>

          <button
            onClick={this.handleReload}
            className="px-6 py-3 bg-[#246BFD] text-white rounded-xl font-semibold hover:bg-blue-700 transition"
          >
            Reload Application
          </button>

          {process.env.NODE_ENV === 'development' && (
            <div className="mt-8 p-4 bg-gray-100 rounded-lg text-left overflow-auto max-w-2xl max-h-48 text-xs font-mono text-red-700 border border-red-200">
              {this.state.error && this.state.error.toString()}
            </div>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
